import { useAuthStateValue } from '@/auth/authentication';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

export const useSentry = () => {
    const authState = useAuthStateValue();

    useEffect(() => {
        if (authState) {
            Sentry.setUser({
                email: authState.email,
                organization: authState.organization.name,
            });
        } else {
            // We do NOT tell Sentry the user is null, as it’s useful to know what the
            //  last signed-in user was, even if they’re not logged in anymore. This especially
            //  helps with debugging authentication issues.
            // Sentry.setUser(null);  // Deliberately commented out.
        }
    }, [authState]);
};
